import useTreatment from './useTreatment'
import EXPERIMENTS from 'constants/experiment'
import clientData from 'lib/client-data'

const useWebAdsEnabled = () => {
  const isWebAdsEnabled = useTreatment({
    name: EXPERIMENTS.WEB_ADS_ENABLED
  })

  // Only show ads to logged-in users and only for users with elmo experiement on
  return isWebAdsEnabled && clientData.isUserLoggedIn
}

export default useWebAdsEnabled
